export default __webpack_public_path__ + "static/shop-pay-affirm-logo-black-78c553496e3ba71be21557e12502a5ab.png";